// ============================================
// Redux Store
// ============================================

import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../redux/slices/authSlice';

const store = configureStore({
    reducer: {
        auth: authReducer,
        // Future slices:
        // admin: adminReducer,
        // driver: driverReducer,
        // dispatcher: dispatcherReducer,
        // booking: bookingReducer,
    },
    devTools: process.env.NODE_ENV !== 'production',
});

export default store;
